module.exports = __webpack_public_path__ + "img/smartz-logo.6b73a6ea.svg";